import { EChannel } from '@/shared/enum/channel.enum'
import { EChannelRouter } from '@/shared/enum/channel-router.enum'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'
import getDecodedToken from '@/shared/utils/get-decoded-token'

/**
 * Determines the channel router based on the provided token or the token stored in local storage.
 * @function currentChannelGuard
 * @param {string|undefined} token - The token to use, or undefined if not provided.
 * @returns {EChannelRouter} The channel router detected based on the given token or local storage.
 */
const getCurrentChannelRouter = (token: string | undefined): EChannelRouter => {
  const currentToken = token ? token : localStorage.getItem(ELocalStorageKey.TOKEN_VALUE)

  if (currentToken) {
    const decodedToken = getDecodedToken(currentToken)

    if (decodedToken?.app === EChannel.MCAPP) {
      return EChannelRouter.MCAPP
    }
    if (decodedToken?.app === EChannel.MCWEB) {
      return EChannelRouter.MCWEB
    }
    if (decodedToken?.cc.toLowerCase() === EChannel.CHATBOT) {
      return EChannelRouter.CHATBOT
    }
  }
  return EChannelRouter.MCE
}

export default getCurrentChannelRouter
